'use client';

import { useTranslations } from 'next-intl';

import { pluginRegistry } from './PluginRegistry';
import './registerPlugins';

import type { Page, SiteConfigResponse, Widget } from '@/lib/api/types';

type WidgetRendererProps = {
  widget: Widget;
  siteData?: {
    site: SiteConfigResponse;
    pages: Page[];
  };
};

export const WidgetRenderer = ({ widget, siteData }: WidgetRendererProps) => {
  const { type, template } = widget;
  const templateKey = template.name;
  const typeKey = type.name;
  const t = useTranslations();
  const plugin = pluginRegistry.getPlugin<typeof widget>(typeKey, templateKey);

  if (!plugin) {
    return (
      <div>
        {t('GENERIC_WIDGET_COMBINATION_HELPER_TEXT')}:{' '}
        <strong>
          {typeKey}-{templateKey}
        </strong>
      </div>
    );
  }

  const { component: SpecificWidget, mapProps } = plugin;
  const propsForComponent = mapProps(widget, siteData);

  return <SpecificWidget {...propsForComponent} />;
};
